import React from "react";
import { useHistory } from "react-router-dom";
import useIsAdvancedSearchMobile from "../hooks/useIsAdvancedSearchMobile";

/**
 * Renderiza la sección de formatos disponibles en la búsqueda avanzada.
 *
 * Muestra una lista de formatos de contenido (libros, audiolibros y videos)
 * que permiten navegar a la ruta correspondiente. Opcionalmente muestra
 * un título para la sección y ejecuta una función al cerrar el menú.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.textos - Objeto con los textos e internacionalización de la interfaz.
 * @param {boolean} [props.showTitle=true] - Indica si debe mostrarse el título de la sección.
 * @param {Function} [props.onClose] - Función opcional que se ejecuta al seleccionar un formato.
 * @returns {JSX.Element} AdvancedSearchFormats
 */
export const AdvancedSearchFormats = ({
    textos,
    showTitle = true,
    onClose,
}) => {
    const history = useHistory();

    const isAdvancedSearchMobile = useIsAdvancedSearchMobile();

    const formats = [
        {
            id: "books",
            label: textos?.content?.formato?.libros || "Libros",
            image: "/img/busqueda-avanzada/libros.png",
            pathname: "/",
        },
        {
            id: "audiobooks",
            label: textos?.content?.formato?.audiolibros || "Audiolibros",
            image: "/img/busqueda-avanzada/audiolibros.png",
            pathname: "/",
        },
        {
            id: "videos",
            label: textos?.content?.formato?.videos || "Videos",
            image: "/img/busqueda-avanzada/videos.png",
            pathname: "/",
        },
    ];

    const handleClick = (format) => {
        history.push({
            pathname: format.pathname,
        });

        onClose && onClose();
    };

    return (
        <section className="mt-4 pt-4 content-format flex-wrap">
            {showTitle && (
                <div className={`col-format ${isAdvancedSearchMobile ? "col-12": "" }`}>
                    <h2 className="section-title">
                        {textos?.content?.titulo4 || "Formato"}
                    </h2>
                </div>
            )}

            <div className="col-format">
                {formats.map((format) => (
                    <button
                        key={format.id}
                        className="btn-format focusable-red"
                        onClick={() => handleClick(format)}
                    >
                        <span>{format.label}</span>

                        <div className="format-img">
                            <img
                                src={format.image}
                                className="img-fluid"
                                alt=""
                                aria-hidden="true"
                            />
                        </div>
                    </button>
                ))}
            </div>
        </section>
    );
};